(() => {
  const body = document.body;
  const q = (s, root = document) => root.querySelector(s);
  const qa = (s, root = document) => [...root.querySelectorAll(s)];
  const toggleLayer = (panel, overlay, open) => {
    if (!panel || !overlay) return;
    panel.classList.toggle('open', open);
    panel.setAttribute('aria-hidden', String(!open));
    overlay.hidden = !open;
    body.classList.toggle('locked', open);
  };
  const menu = q('[data-mobile-menu]');
  const menuOverlay = q('.menu-overlay');
  q('[data-menu-open]')?.addEventListener('click', () => toggleLayer(menu, menuOverlay, true));
  qa('[data-menu-close]').forEach(el => el.addEventListener('click', () => toggleLayer(menu, menuOverlay, false)));
  const drawer = q('[data-cart-drawer]');
  const cartOverlay = q('.cart-overlay');
  const openCart = () => { refreshCart(); toggleLayer(drawer, cartOverlay, true); };
  qa('[data-cart-open]').forEach(el => el.addEventListener('click', openCart));
  qa('[data-cart-close]').forEach(el => el.addEventListener('click', () => toggleLayer(drawer, cartOverlay, false)));
  async function refreshCart() {
    if (!drawer) return;
    const cart = await fetch('/cart.js').then(r => r.json());
    qa('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    q('[data-cart-subtotal]', drawer).textContent = new Intl.NumberFormat(document.documentElement.lang || 'ja-JP', { style: 'currency', currency: cart.currency }).format(cart.total_price / 100);
    const items = q('[data-cart-items]', drawer);
    items.innerHTML = cart.items.length ? cart.items.map(item => `<div class="drawer-line"><img src="${item.image || ''}" alt=""><div><h3>${item.product_title}</h3><p>${item.variant_title || ''}</p><p>数量 ${item.quantity}</p></div><strong>${new Intl.NumberFormat('ja-JP',{style:'currency',currency:cart.currency}).format(item.final_line_price/100)}</strong></div>`).join('') : '<p class="cart-empty">バッグは空です</p>';
  }
  qa('[data-quick-add]').forEach(button => button.addEventListener('click', async () => {
    button.disabled = true;
    try { await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(button.dataset.quickAdd), quantity: 1 }] }) }); openCart(); }
    finally { button.disabled = false; }
  }));
  qa('[data-slideshow]').forEach(show => {
    const slides = qa('[data-slide]', show), dots = qa('[data-slide-dot]', show);
    if (slides.length < 2) return;
    let active = 0;
    const go = i => { active = (i + slides.length) % slides.length; slides.forEach((s, n) => s.classList.toggle('active', n === active)); dots.forEach((d, n) => d.classList.toggle('active', n === active)); };
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    setInterval(() => go(active + 1), Number(show.dataset.interval) || 6000);
  });
  const productSection = q('[data-product-section]');
  if (productSection) {
    const main = q('[data-media-main]', productSection);
    qa('[data-media-thumb]', productSection).forEach(button => button.addEventListener('click', () => {
      qa('[data-media-thumb]', productSection).forEach(b => b.classList.remove('active'));
      button.classList.add('active');
      if (!main) return;
      main.src = button.dataset.mediaSrc;
      main.srcset = button.dataset.mediaSrcset;
      main.alt = button.dataset.mediaAlt || '';
    }));
    const select = q('[data-variant-select]', productSection);
    qa('.variant-options input', productSection).forEach(input => input.addEventListener('change', () => {
      const values = qa('.variant-options input:checked', productSection).map(i => i.value);
      const option = [...select.options].find(o => {
        try { return JSON.stringify(values) === JSON.stringify(JSON.parse(o.dataset.options)); }
        catch (_) { return false; }
      });
      const submit = q('.product-submit', productSection);
      if (option) {
        select.value = option.value;
        q('[data-product-price]', productSection).textContent = option.dataset.price;
        submit.disabled = option.dataset.available !== 'true';
        submit.textContent = option.dataset.available === 'true' ? 'カートに追加' : '売り切れ';
      }
    }));
    q('.product-form', productSection)?.addEventListener('submit', async e => { e.preventDefault(); const form = e.currentTarget; const button = q('.product-submit', form); button.disabled = true; try { await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } }); openCart(); } finally { button.disabled = false; } });
  }
  q('[data-sort-by]')?.addEventListener('change', e => { const url = new URL(location.href); url.searchParams.set('sort_by', e.target.value); location.href = url.toString(); });
})();
